export default __webpack_public_path__ + "static/media/smiling2.0a6d38da.jpg";